import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import LatestUpdates from './components/LatestUpdates';
import Features from './components/Features';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '久久在线观看',
    url: 'https://mobiang.cn/',
    description: '久久在线观看，为您提供海量高清视频资源，无需下载即可流畅播放。电影、电视剧、综艺、动漫应有尽有。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://mobiang.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '久久在线观看',
    url: 'https://mobiang.cn/',
    description: '高清视频免费畅享平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      email: 'contact@jiujiuzaixian.com',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '久久在线观看 – 高清视频免费畅享平台',
    description: '久久在线观看，为您提供海量高清视频资源，无需下载即可流畅播放。电影、电视剧、综艺、动漫应有尽有。',
    url: 'https://mobiang.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '久久在线观看',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>

      <div className="min-h-screen">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedVideos />
          <LatestUpdates />
          <Features />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}